import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login/login.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/dashboard/dashboard.vue')
  },
  {
    path: '/dashboard/left',
    name: 'dashboardLeftDetail',
    component: () => import('../views/dashboard/leftPanel.vue')
  },
  {
    path: '/dashboard/right',
    name: 'dashboardRightDetail',
    component: () => import('../views/dashboard/rightPanel.vue')
  },
  {
    path: '/index',
    name: 'indexView',
    component: () => import('../views/index/index.vue')
  },
  {
    path: '/me',
    name: 'me',
    component: () => import('../views/me/me.vue')
  },
  {
    path: '/device',
    name: 'device',
    component: () => import('../views/index/device.vue')
  },
  {
    path: '/device/:id',
    name: 'deviceView',
    component: () => import('../views/index/device.vue')
  },
  {
    path: '/watch',
    name: 'watch',
    component: () => import('../views/index/watch.vue')
  },
  {
    path: '/history',
    name: 'history',
    component: () => import('../views/index/history.vue')
  },
  {
    path: '/alert',
    name: 'alert',
    component: () => import('../views/index/alert.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
